<div class="card">
    <slot></slot>
</div>


<style>
    .card {
        background-color: #fff;
        border-radius: 15px;
        padding: 40px 50px;
        margin: 20px 0;
        position: relative;
        color:#333;
    }
</style>